module.exports = __webpack_public_path__ + "img/bg-handover-sti-late.5a4e077d.svg";